var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","placement":"right","content":_vm.isActive ? '点击折叠菜单': '点击展开菜单'}},[_c('div',{staticClass:"hamburger",class:{'is-active':_vm.isActive},on:{"click":_vm.toggleClick}},[_c('i',{staticClass:"QS-icon-caret-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }